import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBarChart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.75 15.75H4.08333C2.24238 15.75 0.75 14.2576 0.75 12.4167V0.75M4.91667 12.4167V9.08333M9.08333 12.4167V3.25M13.25 12.4167V5.75",
		stroke: "#18181B",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgBarChart);
export default ForwardRef;
